import { Component, OnInit, Input } from '@angular/core';
import { BcAccountClientService } from './../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Subscription } from "rxjs/Rx";
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';

@Component({
	selector: 'app-bc-juridical-proposal',
	templateUrl: './bc-juridical-proposal.component.html',
	styleUrls: ['./bc-juridical-proposal.component.scss']
})

export class BcJudicialProposalComponent implements OnInit {

	@Input('juridicalProposalID') juridicalProposalID = [];
	@Input('clientID') clientID = "";

	public payHistoricTotal: number = 0;
	public load: boolean = true;
	public loginSubcription = new Subscription;
	public permissoes: any[] = [];
	public juridicalProposal: any[] = [];

	constructor(private bcAccountClientService: BcAccountClientService, private flashMessagesService: FlashMessagesService, private router: Router) { }

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.getJuridicProposal();
	}

	save() {
		var obj = {
			ID: this.juridicalProposal['ID'],
			ParecerCobranca: this.juridicalProposal['ParecerCobranca'],
			Pedidos: this.juridicalProposal['Pedidos'],
			NotaFiscal: this.juridicalProposal['NotaFiscal'],
			Comprovante: this.juridicalProposal['Comprovante']
		}

		this.bcAccountClientService.saveJuridicProposal(obj).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta salva com sucesso", { cssClass: 'alert-success', timeout: 6000 });
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	sendJuridico() {
		var obj = {
			ID: this.juridicalProposal['ID'],
			ContaClienteID: this.clientID
		}

		this.bcAccountClientService.sendJuridico(obj).subscribe(blob => {
			if (blob) {
				this.flashMessagesService.show("Proposta enviada ao Jurídico", { cssClass: 'alert-success', timeout: 6000 });
				saveAs(blob, this.juridicalProposal['NumeroProposta'] + '.msg');
				this.router.navigateByUrl('/').then(
					() => {
						this.router.navigate(['/conta-cliente/detalhe', this.clientID, 'cobranca']);
					});
			} else {
				this.flashMessagesService.show("Ocorreu um erro ao tentar enviar a Proposta ao Jurídico", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});

	}

	cancelJuridico() {
		var id = this.juridicalProposal['ID'];

		this.bcAccountClientService.cancelJuridico(id).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta de Envio ao Jurídico cancelada", { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/').then(
					() => {
						this.router.navigate(['/conta-cliente/detalhe', this.clientID, 'cobranca']);
					});
			} else {
				this.flashMessagesService.show("Ocorreu um erro ao tentar cancelar a Proposta de Envio ao Jurídico", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getJuridicProposal() {
		this.bcAccountClientService.getJuridicProposal(this.juridicalProposalID).subscribe(result => {
			if (result.Success) {
				this.juridicalProposal = result.Result;

				// Calcular Total
				var paymentList = this.juridicalProposal['PropostaJuridicoHistoricoPagamentos'];

				this.payHistoricTotal = 0;

				paymentList.forEach(pay => {
					this.payHistoricTotal += pay['ValorDocumento'];
				});

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getPropostalStatus(statusID) {
		switch(statusID)
		{
			case "EA": return "Em Aprovação";
			case "AP": return "Aprovada";
			case "CA": return "Cancelada";
			default: return "";
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-juridical-proposal/bc-juridical-proposal.component.ts